import { render, staticRenderFns } from "./DetailStatistical.vue?vue&type=template&id=acefee36&scoped=true&"
import script from "./DetailStatistical.vue?vue&type=script&lang=js&"
export * from "./DetailStatistical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acefee36",
  null
  
)

export default component.exports